const footerUpper = (() => {    
    const initBlock = (el => {
        el.addEventListener('click', () => {
            const items = el.querySelectorAll('[data-items]');
            if (items.length > 0){
                items.forEach(item =>{
                    item.toggleAttribute("data-active");
                })
            }
            const icon = el.querySelector('svg');
            if (icon){
                icon.toggleAttribute("data-active");
            }
        })
    });    
    return {initBlock};
})();
ControlBinders.register('[data-footer-column]', el => footerUpper.initBlock(el));